import { z } from 'zod';

export const OpportunitySubmissionSelectedCandidateSchema = z.object({
  isActiveForSubmission: z.boolean().nullish(),
});

export type SelectedCandidate = z.infer<
  typeof OpportunitySubmissionSelectedCandidateSchema
>;
